// footerData.js — Footer content configuration

const footerData = {
  brand: {
    name: 'Properties In Finite',
    tagline: 'Turning Your Property Dreams Into Reality',
    description:
      'Connecting buyers, sellers, and renters across India with verified listings and transparent pricing.',
    contact_phone: '9360302741',
    contact_email: 'support@propertiesinfinite.com',
  },

  columns: [
    {
      id: 1,
      heading: 'Company',
      links: [
        { label: 'About Us',       path: '/about'           },
        { label: 'Privacy Policy', path: '/privacy-policy'  },
        { label: 'Terms of Use',   path: '/terms'           },
        { label: 'Careers',        path: '/careers'         },
      ],
    },
    {
      id: 2,
      heading: 'Properties',
      links: [
        { label: 'Buy Property',   path: '/properties'      },
        { label: 'Rent Property',  path: '/properties/rent' },
        { label: 'New Projects',   path: '/properties?kind=project'        },
        { label: 'Post Free Ad',   path: '/role?context=property'   },
      ],
    },
    {
      id: 3,
      heading: 'Cities',
      links: [
        { label: 'Chennai',        path: '/properties?city=1'  },
        { label: 'Bengaluru',      path: '/properties?city=5'  },
        { label: 'Mumbai',         path: '/properties?city=12' },
        { label: 'Hyderabad',      path: '/properties?city=11' },
        { label: 'Coimbatore',     path: '/properties?city=3'  },
        { label: 'Kochi',          path: '/properties?city=7'  },
      ],
    },
  ],

  socials: [
    { id: 1, label: 'Facebook',  url: 'https://www.facebook.com/share/1DqJbpvacC/',  icon: 'fb'  },
    { id: 2, label: 'Instagram', url: 'https://www.instagram.com/properties_in_finite/', icon: 'ig'  },
    { id: 3, label: 'Twitter',   url: 'https://twitter.com',   icon: 'tw'  },
    { id: 4, label: 'YouTube',   url: 'https://www.youtube.com/@PropertiesInfinite',   icon: 'yt'  },
  ],

  copyright: `© ${new Date().getFullYear()} Properties In Finite. All rights reserved.`,
};

export default footerData;